import axios from 'axios'

const CONFIG_URL = 'api/configurations'
const SCHEDULE_URL = 'api/schedules'
const TRIGGER_URL = 'cdi/api/ingestion/trigger'
const PHOTO_URL = 'cdi/api/ingestion/station-photos'
const JOBS_URL = 'api/logs/jobs'
const ENTRIES_URL = 'api/logs/entries'

const STATION_PHOTO_SOURCE_TYPE = 'StationPhotos'
const STATION_PHOTO_SOURCE_TYPE_VALUE = '6'

const initialState = () => ({
  configurations: [],
  schedules: [],
  jobs: [],
  jobsTotalCount: 0,
  logEntries: [],
  logEntriesTotalCount: 0,
})

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    configurations: s => s.configurations,
    schedules: s => s.schedules,
    jobs: s => s.jobs,
    jobsTotalCount: s => s.jobsTotalCount,
    logEntries: s => s.logEntries,
    logEntriesTotalCount: s => s.logEntriesTotalCount,
    stationPhotoTypeConfiguration: s => ({ name: STATION_PHOTO_SOURCE_TYPE, value: STATION_PHOTO_SOURCE_TYPE_VALUE }),

  },
  mutations: {
    RESET(state) {
      const initial = initialState()
      Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
    SET_CONFIGURATIONS(state, data) { state.configurations = data },
    ADD_CONFIGURATION(state, data) { state.configurations.push(data) },
    UPDATE_CONFIGURATION(state, data) {
      const idx = state.configurations.findIndex(x => x.Id === data.Id)
      if (idx >= 0) state.configurations.splice(idx, 1, data)
    },
    REMOVE_CONFIGURATION(state, id) {
      state.configurations = state.configurations.filter(x => x.Id !== id)
    },
    SET_SCHEDULES(state, data) { state.schedules = data },
    ADD_SCHEDULE(state, data) { state.schedules.push(data) },
    UPDATE_SCHEDULE(state, data) {
      const idx = state.schedules.findIndex(x => x.Id === data.Id)
      if (idx >= 0) state.schedules.splice(idx, 1, data)
    },
    REMOVE_SCHEDULE(state, id) {
      state.schedules = state.schedules.filter(x => x.Id !== id)
    },
    SET_JOBS(state, data) { state.jobs = data },
    SET_JOBS_TOTAL(state, val) { state.jobsTotalCount = val },
    SET_LOG_ENTRIES(state, data) { state.logEntries = data },
    SET_LOG_ENTRIES_TOTAL(state, val) { state.logEntriesTotalCount = val },
  },
  actions: {
    // --- Configurations ---
    async fetchConfigurations({ commit }, { isActive, successCb, failedCb } = {}) {
      try {
        const params = isActive !== undefined ? { isActive } : {}
        const res = await axios.get(CONFIG_URL, { params })
        commit('SET_CONFIGURATIONS', res.data)
        if (successCb) successCb(res.data)
      } catch (err) { if (failedCb) failedCb(err) }
    },
    async getConfiguration({ commit }, { id, successCb, failedCb }) {
      try {
        const res = await axios.get(`${CONFIG_URL}/${id}`)
        if (successCb) successCb(res.data)
      } catch (err) { if (failedCb) failedCb(err) }
    },
    async createConfiguration({ commit }, { data, successCb, failedCb }) {
      try {
        const res = await axios.post(CONFIG_URL, data)
        commit('ADD_CONFIGURATION', res.data)
        if (successCb) successCb(res.data)
      } catch (err) { if (failedCb) failedCb(err) }
    },
    async updateConfiguration({ commit }, { id, data, successCb, failedCb }) {
      try {
        const res = await axios.put(`${CONFIG_URL}/${id}`, data)
        commit('UPDATE_CONFIGURATION', res.data)
        if (successCb) successCb(res.data)
      } catch (err) { if (failedCb) failedCb(err) }
    },
    async deleteConfiguration({ commit }, { id, successCb, failedCb }) {
      try {
        await axios.delete(`${CONFIG_URL}/${id}`)
        commit('REMOVE_CONFIGURATION', id)
        if (successCb) successCb()
      } catch (err) { if (failedCb) failedCb(err) }
    },

    // --- Schedules ---
    async fetchSchedules({ commit }, { isActive, successCb, failedCb } = {}) {
      try {
        const params = isActive !== undefined ? { isActive } : {}
        const res = await axios.get(SCHEDULE_URL, { params })
        commit('SET_SCHEDULES', res.data)
        if (successCb) successCb(res.data)
      } catch (err) { if (failedCb) failedCb(err) }
    },
    async createSchedule({ commit }, { data, successCb, failedCb }) {
      try {
        const res = await axios.post(SCHEDULE_URL, data)
        commit('ADD_SCHEDULE', res.data)
        if (successCb) successCb(res.data)
      } catch (err) { if (failedCb) failedCb(err) }
    },
    async updateSchedule({ commit }, { id, data, successCb, failedCb }) {
      try {
        const res = await axios.put(`${SCHEDULE_URL}/${id}`, data)
        commit('UPDATE_SCHEDULE', res.data)
        if (successCb) successCb(res.data)
      } catch (err) { if (failedCb) failedCb(err) }
    },
    async deleteSchedule({ commit }, { id, successCb, failedCb }) {
      try {
        await axios.delete(`${SCHEDULE_URL}/${id}`)
        commit('REMOVE_SCHEDULE', id)
        if (successCb) successCb()
      } catch (err) { if (failedCb) failedCb(err) }
    },
    async assignConfigToSchedule({ commit }, { scheduleId, configurationId, successCb, failedCb }) {
      try {
        await axios.post(`${SCHEDULE_URL}/${scheduleId}/configurations`, { ConfigurationId: configurationId })
        if (successCb) successCb()
      } catch (err) { if (failedCb) failedCb(err) }
    },
    async removeConfigFromSchedule({ commit }, { scheduleId, configId, successCb, failedCb }) {
      try {
        await axios.delete(`${SCHEDULE_URL}/${scheduleId}/configurations/${configId}`)
        if (successCb) successCb()
      } catch (err) { if (failedCb) failedCb(err) }
    },
    async fetchScheduleConfigs({ commit }, { scheduleId, successCb, failedCb }) {
      try {
        const res = await axios.get(`${SCHEDULE_URL}/${scheduleId}/configurations`)
        if (successCb) successCb(res.data)
      } catch (err) { if (failedCb) failedCb(err) }
    },

    // --- Triggers ---
    async triggerIngestion({ commit }, { configurationIds, successCb, failedCb } = {}) {
      try {
        const payload = configurationIds && configurationIds.length > 0
          ? { ConfigurationIds: configurationIds } : {}
        const res = await axios.post(TRIGGER_URL, payload)
        if (successCb) successCb(res.data)
      } catch (err) { if (failedCb) failedCb(err) }
    },
    async triggerSchedule({ commit }, { scheduleId, successCb, failedCb }) {
      try {
        const res = await axios.post(`${SCHEDULE_URL}/${scheduleId}/trigger`)
        if (successCb) successCb(res.data)
      } catch (err) { if (failedCb) failedCb(err) }
    },

    // --- Photo Upload ---
    async uploadPhotos({ commit }, { formData, successCb, failedCb }) {
      try {
        const res = await axios.post(PHOTO_URL, formData)
        if (successCb) successCb(res.data)
      } catch (err) { if (failedCb) failedCb(err) }
    },

    // --- Job Runs ---
    async fetchJobRuns({ commit }, { params, successCb, failedCb } = {}) {
      try {
        const res = await axios.get(JOBS_URL, { params })
        commit('SET_JOBS', res.data.Items || [])
        commit('SET_JOBS_TOTAL', res.data.TotalCount || 0)
        if (successCb) successCb(res.data)
      } catch (err) { if (failedCb) failedCb(err) }
    },
    async fetchJobRun({ commit }, { id, successCb, failedCb }) {
      try {
        const res = await axios.get(`${JOBS_URL}/${id}`)
        if (successCb) successCb(res.data)
      } catch (err) { if (failedCb) failedCb(err) }
    },

    // --- Log Entries ---
    async fetchLogEntries({ commit }, { params, successCb, failedCb } = {}) {
      try {
        const res = await axios.get(ENTRIES_URL, { params })
        commit('SET_LOG_ENTRIES', res.data.Items || [])
        commit('SET_LOG_ENTRIES_TOTAL', res.data.TotalCount || 0)
        if (successCb) successCb(res.data)
      } catch (err) {
        commit('SET_LOG_ENTRIES', [])
        commit('SET_LOG_ENTRIES_TOTAL', 0)
        if (failedCb) failedCb(err)
      }
    },
  },
}
